import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router, UrlTree } from '@angular/router';
import { ApplicationBaseData, ApplicationOffer, DomHelper, MessageService, parseNumber } from 'common';
import { ApplicationService } from '../application.service';
import { SendOfferEmailComponent } from './send-offer-email/send-offer-email.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifa-share-offer',
    templateUrl: './share-offer.component.html',
    styleUrls: ['./share-offer.component.scss'],
    standalone: false
})
export class ShareOfferComponent implements OnInit {
  @Input() offer: ApplicationOffer;
  @Input() emailBody: string;

  application: ApplicationBaseData
  uuid: string
  bundleId: number
  offerId: number
  shareUrl: string
  customerUrlTree: UrlTree

  constructor(
    private readonly dialog: MatDialog,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly applicationService: ApplicationService,
    private readonly messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.pipe(untilDestroyed(this)).subscribe(params => {
      this.uuid = params.get("uuid");
      this.bundleId = parseNumber(params.get("bundleId"));

      this.applicationService.getByUUID(this.uuid)
        .subscribe(this.dataInit.bind(this));
      });
  }

  private dataInit(data: ApplicationBaseData): void {
    this.application = data;
    this.route.url.subscribe(url=>{
      this.customerUrlTree = this.router.createUrlTree(['preview/' + url[0].path], { queryParams: {uuid: this.uuid, bundleId: this.bundleId}});
      this.shareUrl =  window.location.origin + this.customerUrlTree.toString();
    });

}

  sendEmailOffer(): void {
    SendOfferEmailComponent.show(this.dialog, this.application, this.shareUrl, this.offer, this.emailBody);
  }

  copy(): void {
    DomHelper.copy(this.shareUrl);
    this.messageService.info('Link copied');
  }

  customerView(): void {
    this.route.url.subscribe(() =>{
      this.router.navigateByUrl(this.customerUrlTree);
    });
  }
}
